import { InertiaLink } from '@inertiajs/inertia-react'
import Icon from 'components/Icon'
import React, { useState } from 'react'
import route from 'ziggy-js'
import FooterButton from '../FooterButton'
import Img from '../Image'
import { _ } from '../Translator'
import { motion } from "framer-motion";


export function FooterButtonCatering() {

    const [hover, setHover] = useState(false)

    const scrollToDemandCard = () => {
        // Scroll to the demand card element
        const demandCard = document.getElementById('demand-card');
        if (demandCard) {
            demandCard.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div

            className="w-200px mob:my-48px cursor-pointer h-200px flex items-center justify-center relative" onPointerEnter={() => setHover(true)} onPointerLeave={() => setHover(false)}>
            <div onClick={scrollToDemandCard} className="text-64 font-aldo font-semibold font-outline z-10 whitespace-nowrap leading-[64px]"><_>Poptávka</_></div>
            <motion.div
                animate={{
                    scale: hover ? 1.25 : 1
                }}
                transition={{
                    duration: 0.5
                }}
                className="absolute top-0 left-0 right-0 bottom-0 z-0"
            >
                <div style={{ transform: 'rotate(15deg)' }}>
                    <Img layout="fill" objectFit="contain" src="/assets/img/catering/small_logo_footer.png" />
                </div>
            </motion.div>
        </div>
    )
}


interface Props {
    onlyReserve?: boolean
    dark?: boolean
}

function FooterCatering(props: Props) {
    const { onlyReserve, dark } = props

    let now = new Date().getFullYear()

    return (
        <footer className={"z-0 bg-[#8BACB7] w-full pt-40px h-auto md:h-450px md:fixed bottom-0 text-black px-0 flex justify-center " + (dark ? " bg-brown-light " : " bg-[#8BACB7]") + (onlyReserve ? " md:pr-60px " : " md:px-60px ")}>
            <div className="max-w-6xl p-16px md:p-25px w-full grid grid-cols-1 md:grid-cols-2">
                <div className="flex flex-col justify-start items-start">
                    <div className="hidden md:block mb-20px">
                        <Img src="/assets/img/catering/catering_logo_footer.svg" width="150px" />
                    </div>
                    <div className="flex md:hidden justify-between w-full">
                        <Img src="/assets/img/catering/catering_logo_footer.svg" width="150px" />
                        {/* <div className="md:hidden flex gap-x-16px">
                            <a target="_blank" href="https://www.instagram.com/cafenewone/?hl=cs"><Icon name="instagram" /></a>
                            <Icon name="facebook" />
                        </div> */}
                        <div className="nMob:hidden flex right-0 top-0 md:flex items-center gap-x-16px">
                            <a target="_blank" href="https://www.instagram.com/cafenewone/" className="hover:opacity-75 flex items-center">
                                <Img src="/assets/img/catering/Instagram_logo.svg" alt="Instagram" className="block w-[24px] h-[24px]" />
                            </a>
                            <a target="_blank" href="https://www.facebook.com/cafenewone/" className="hover:opacity-75 flex items-center">
                                <Img src="/assets/img/catering/Facebook_logo.svg" alt="Facebook" className="block w-[24px] h-[24px]" />
                            </a>
                        </div>
                    </div>

                    <div className="text-16 text-black text-opacity-50 mt-20px mb-48px">
                        <_>Neustále překvapovat, vždy nadchnout
                        </_>
                    </div>
                    <div className="grid grid-cols-2 w-full gap-16px text-16 cursor-pointer">
                        <InertiaLink href={route('menu')} className=" hover:opacity-75"><_>Denní menu</_></InertiaLink>
                        <InertiaLink href={route('pribeh')} className=" hover:opacity-75"><_>Příběh</_></InertiaLink>
                        <InertiaLink href={route('menu')} className=" hover:opacity-75"><_>Menu</_></InertiaLink>
                        <InertiaLink href={route('kontakt')} className=" hover:opacity-75"><_>Kontakt</_></InertiaLink>
                        <InertiaLink href={route('eventy')} className=" hover:opacity-75"><_>Eventy</_></InertiaLink>
                        <InertiaLink href={route('rezervace')} className=" hover:opacity-75"><_>Rezervace</_></InertiaLink>
                    </div>
                </div>

                <div className="relative flex mob:flex mob:flex-col items-center justify-center">
                    <div className=" mob:hidden absolute right-0 top-0 md:flex items-center gap-x-16px">
                        <a target="_blank" href="https://www.instagram.com/cafenewone/" className="hover:opacity-75 flex items-center">
                            <Img src="/assets/img/catering/Instagram_logo.svg" alt="Instagram" className="block w-[24px] h-[24px]" />
                        </a>
                        <a target="_blank" href="https://www.facebook.com/cafenewone/" className="hover:opacity-75 flex items-center">
                            <Img src="/assets/img/catering/Facebook_logo.svg" alt="Facebook" className="block w-[24px] h-[24px]" />
                        </a>
                    </div>
                    <FooterButtonCatering />

                </div>

                <div className="md:col-span-2 mob:pb-32px  bg-[#8BACB7] mob:mt-16px block md:flex justify-between w-full text-black">
                    <div className=" md:py-40px">
                        © 2014 - {now}, Café New One, BALASHOUSE s. r. o., tř. Svobody 596/21, 779 00 Olomouc, IČ: 02663163
                    </div>
                    <div className=" bg-[#8BACB7] mob:w-full mob:pt-8px md:py-40px ">
                        <a href="/assets/cafenewone_GDPR.pdf" target="_blank" className="hover:opacity-75 text-black "><_> <span className='underline'>GDPR </span> | </_></a>
                        <span className="text-black"><_> Obchodní podmínky</_></span>
                    </div>
                </div>

            </div>

        </footer>
    )
}

export default FooterCatering

